import { render, staticRenderFns } from "./crop_info.vue?vue&type=template&id=60d87d0e&"
import script from "./crop_info.vue?vue&type=script&lang=js&"
export * from "./crop_info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports